import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { ChevronLeftSquare } from '@withjoy/joykit/icons';
import { Flex, IconV2Props, TextV2 } from '@withjoy/joykit';
import { ScrollableArea } from '@website-editor/utils/WebsiteEditor.utils';

export type LayoutFormProps = {
  icon?: React.ComponentType<IconV2Props>;
  title: string;
  subTitle: string;
  isAnimating?: boolean;
  handleOnClose: () => void;
};

export const LayoutForm: React.FC<LayoutFormProps> = ({ icon, title, subTitle, isAnimating, handleOnClose, children }) => {
  let Icon;
  if (icon) {
    Icon = icon;
  }

  return (
    <ScrollableArea
      backgroundColor="white"
      flexDirection="column"
      maxHeight="100%"
      width="100%"
      overflowY="auto"
      alignItems="center"
      borderRight={['0px solid', '1px solid']}
      borderColor={['mono3', 'mono3']}
      transparentScrollbar={isAnimating}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        width="100%"
        height="100%"
        paddingX={{ _: 7, sm2: 8 }}
        paddingTop={7}
      >
        <Flex
          borderRadius={48}
          border="1px solid"
          borderColor="mono3"
          background="white"
          width={8}
          height={8}
          position="absolute"
          padding={2}
          justifyContent="center"
          alignItems="center"
          gap={3}
          left={pxToRem(20)}
          cursor="pointer"
          top={pxToRem(20)}
          zIndex={999}
          onClick={handleOnClose}
          _hover={{
            backgroundColor: 'mono3',
            borderColor: 'mono5',
          }}
          _active={{
            backgroundColor: 'mono5',
            borderColor: 'mono5',
          }}
        >
          <ChevronLeftSquare size={16} />
        </Flex>
        <Flex
          flexDirection="column"
          gap={4}
          alignItems="center"
          marginBottom={7}
        >
          {Icon && <Icon size={48} />}
          <Flex
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            gap={1}
            maxWidth={320}
          >
            <TextV2
              typographyVariant="hed6"
              color="mono14"
            >
              {title}
            </TextV2>
            <TextV2
              color="mono12"
              fontSize={pxToRem(17)}
              lineHeight={pxToRem(25.5)}
            >
              {subTitle}
            </TextV2>
          </Flex>
        </Flex>
        {children}
      </Flex>
    </ScrollableArea>
  );
};
